import React, { useEffect, useState, useRef } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";

const VenueDetailsSection = () => {
  const [venues, setVenues] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVenue, setSelectedVenue] = useState(null);

  const modalRef = useRef(null);

  // Fetch venue data
  const fetchVenueData = async () => {
    try {
      const response = await corefetch("Facility/GetVenueHighlightsSection");
      if (response) {
        setVenues(response);
      } else {
        console.error("No venue data received.");
      }
    } catch (error) {
      console.error("Failed to fetch venue data", error);
    }
  };

  useEffect(() => {
    fetchVenueData();
  }, []);

  useEffect(() => {
    if ($(".rooms1-carousel").length) {
      $(".rooms1-carousel").owlCarousel({
        loop: true,
        margin: 30,
        autoHeight: false,
        autoplay: true,
        autoplayTimeout: 3000,
        dots: false,
        nav: true,
        navText: [
          '<i class="ti-angle-left" aria-hidden="true"></i>',
          '<i class="ti-angle-right" aria-hidden="true"></i>',
        ],
        responsiveClass: true,
        responsive: {
          0: {
            dots: false,
            items: 1,
          },
          600: {
            dots: false,
            items: 1,
          },
          1000: {
            dots: false,
            items: 1,
          },
        },
      });
    }

    return () => {
      $(".rooms1-carousel").trigger("destroy.owl.carousel");
    };
  }, [JSON.stringify(venues)]);

  // Handle closing modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };

    window.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const openModal = (venue) => {
    setSelectedVenue(venue);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  if (!venues || venues.length == 0) {
    return null;
  }

  return (
    <>
      <section className="rooms1 section-padding">
        <div className="container">
          <div className="row mb-30">
            <div className="col-md-3">
              <div className="sub-title border-bot-light">Discover</div>
            </div>
            <div className="col-md-9">
              <div className="section-title">Venue Details</div>
            </div>
          </div>
          <div className="rooms1-carousel owl-theme owl-carousel">
            {venues.map((venue, index) => (
              <div key={index} className="rooms1-single">
                <div className="rooms1-img">
                  <img
                    src={`${ImageURL}${venue.oldImagePath}`}
                    alt={venue.facilityName}
                    onClick={() => openModal(venue)}
                    className="pointer"
                    style={{ objectFit: "cover", objectPosition: "top" }}
                  />
                </div>
                <div className="rooms1-content">
                  <div className="row">
                    <div className="col-md-6">
                      <div
                        className="rooms1-title"
                        // style={{ textAlign: "center" }}
                      >
                        <a href={`/facilityMain/${venue.facilityID}`}>
                          {venue.facilityName}
                        </a>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="book">
                        <div>
                          <a
                            className="butn-dark2"
                            href={`/facilityMain/${venue.facilityID}`}
                          >
                            <span>Explore</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal for Venue Details */}
      {isModalOpen && selectedVenue && (
        <div className="popup">
          <div className="modal-content venues" ref={modalRef}>
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <div className="modal-header venues">
              <div className="col-6">{selectedVenue.facilityName}</div>
              <div className="col-6 d-flex mt-4 custom-font">
                <div className="col-8 text-center">
                  <a
                    className="butn-dark2"
                    href={selectedVenue.detailedView}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>Virtual Tour</span>
                  </a>
                </div>

                <div className="col-4">
                  <a className="butn-dark2" href="#">
                    <span>Gallery</span>
                  </a>
                </div>
              </div>
            </div>
            <div className="additional-text">
              <p>{selectedVenue.description || "No description available."}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VenueDetailsSection;
